import ViewListIcon from '@mui/icons-material/ViewList'
import ViewModuleIcon from '@mui/icons-material/ViewModule'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { setBusqueda } from '../../actions/articulos'
import { setFamiliaSeleccionada } from '../../actions/familias'
import { anadirFiltro, getFiltros, limpiarFiltros } from '../../actions/filtros'
import '../../css/articulos.css'
import ArticulosFiltros from './ArticulosFiltros'
import ListadoArticulos from './ListadoArticulos'

let estadistico_url
let familia_url
let descrip_url

const Articulos = () => {
  const filtros = useSelector(state => state.articulos.filtros)
  const filtros_claves_estadisticas = useSelector(
    state => state.articulos.filtros_claves_estadisticas,
  )

  const dispatch = useDispatch()
  const [vista, setVista] = useState(() => sessionStorage.getItem('articulos_vista') || 'lista')
  const navigate = useNavigate()

  useEffect(() => {
    if (estadistico_url && familia_url && descrip_url) {
      dispatch(limpiarFiltros())
      dispatch(setBusqueda(''))
      dispatch(setFamiliaSeleccionada(estadistico_url, familia_url, ''))
      dispatch(
        anadirFiltro({
          estadistico: estadistico_url,
          familia: familia_url,
          nombre: '',
          tipo: 'estad',
        }),
      )
    }

    if (
      filtros === undefined ||
      filtros.filtros === undefined ||
      filtros.filtros.length === 0 ||
      filtros_claves_estadisticas === undefined ||
      filtros_claves_estadisticas.filtros_claves_estadisticas === undefined ||
      filtros_claves_estadisticas.filtros_claves_estadisticas.length === 0
    ) {
      dispatch(getFiltros())
    }
  }, [])

  useEffect(() => {
    window.wookie()
  })

  // Partimos la URL
  let url = window.location.pathname
  let splittedURL = url.split('/')
  // Cogemos el codigo_articulo

  if (splittedURL[2] && splittedURL[3] && splittedURL[4]) {
    estadistico_url = splittedURL[2]
    familia_url = splittedURL[3]
    descrip_url = splittedURL[4]
  }
  const filtro_url =
    estadistico_url && familia_url && descrip_url
      ? {
          estadistico: estadistico_url,
          familia: familia_url,
          nombre: descrip_url,
        }
      : null

  return (
    <div style={{ width: '100%' }}>
      <div className='container-listado-articulos container'>
        <div
          id='tt-pageContent'
          className='articulos'>
          <div className='container-indent'>
            <div className='container-fluid-custom container-fluid-custom-mobile-padding'>
              <div
                className='row'
                style={{ flexDirection: 'row-reverse' }}>
                <div style={{ display: 'none' }}>
                  <ArticulosFiltros filtro_url={filtro_url} />
                </div>
                <div className='col-md-12 col-lg-12 col-xl-12'>
                  <div
                    style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px' }}>
                    <ToggleButtonGroup
                      value={vista}
                      exclusive
                      onChange={(_, nuevaVista) => {
                        if (nuevaVista) {
                          setVista(nuevaVista)
                          sessionStorage.setItem('articulos_vista', nuevaVista)
                        }
                      }}
                      size='small'>
                      <ToggleButton
                        value='lista'
                        title='Vista en cuadrícula'>
                        <ViewModuleIcon />
                      </ToggleButton>
                      <ToggleButton
                        value='tabla'
                        title='Vista en tabla'>
                        <ViewListIcon />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </div>
                  <ListadoArticulos
                    origen='articulos'
                    mostrar={vista === 'tabla' ? 'tabla_casals' : 'lista'}
                    filtro_url={filtro_url}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Articulos
